import { PaginationResponse } from '../rewards/rewards-types';

export enum CCRewardsEventGroups {
    CC_CARD_MONTH_SUMMARY = 'cc-card-month-summary',
    CC_MONTH_YEAR_BREAKDOWN = 'cc-month-year-breakdown',
    CC_MONTH_YEAR_COMPARISON = 'cc-month-year-comparison',
    CC_TRANSACTIONS = 'cc-transactions',
}

export interface CCUserCardRewardInfo {
    userCardRewardId?: string;
}

export interface CCCardMonthSummary {
    isCurrentMonthYear: boolean;
    isDefault: boolean;
    maskedNumber: string;
    monthlyEarningsCents: number;
    monthlySpendCents: number;
    monthYear: string;
    network: string;
    networkImage: string;
    nextExpectedPayoutDate: string;
    payoutStatus: string;
    userCardRewardId: string;
}

export type GetCCCardMonthSummaryResponse = CCCardMonthSummary[];

export interface CCMonthlyBreakdown {
    cashbackAmountCents: number;
    categoryCashbackPercentage: number;
    categoryId: string;
    categoryImageUrl: string;
    categoryName: string;
}

export enum CategoryProgramType {
    FLAT = 'flat',
    VARIABLE = 'variable',
}

export enum UserCardRewardState {
    CASHBACK_PAID = 'cashback-paid',
    CASHBACK_PENDING = 'cashback-pending',
    NO_SPEND = 'no-spend',
}

export type CCMonthlyBreakdownResponse = {
    breakdown: CCMonthlyBreakdown[];
    categoryProgramType: CategoryProgramType;
    userCardRewardState: UserCardRewardState;
};

export interface CCMonthlyComparison {
    cashbackAmountCents: number;
    isCurrentMonth: boolean;
    monthYear: string;
}

export type CCMonthlyComparisonResponse = {
    cashbackEarnedThisYearCents: number;
    comparison: CCMonthlyComparison[];
    userCardRewardState: UserCardRewardState;
};

export enum CCTransactionStatus {
    PAID = 'paid',
    PENDING = 'pending',
}

export interface CCTransaction {
    cashbackAmountCents: number;
    categoryCashbackPercentage: number;
    categoryId: string;
    categoryName: string;
    maskedNumber: string;
    name: string;
    network: string;
    networkImage: string;
    purchaseAmountCents: number;
    status: CCTransactionStatus;
    transactionDate: string;
    transactionDescription: string;
    transactionId: string;
}

export type CCTransactionsResponse = {
    data: CCTransaction[];
    pagination: PaginationResponse;
};
